import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '01',
  title: 'Discover',
  desc: 'Browse our exclusive portfolio to find the property that matches your vision.',
  image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}, {
  num: '02',
  title: 'Inspect',
  desc: 'Schedule a physical or virtual tour with our dedicated property consultants.',
  image: 'https://images.unsplash.com/photo-1582407947304-fd86f028f716?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}, {
  num: '03',
  title: 'Acquire',
  desc: 'Complete the transparent documentation and payment process securely.',
  image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}, {
  num: '04',
  title: 'Move In',
  desc: 'Receive your keys and step into your new premium living space.',
  image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}];
export function Process() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isHovering, setIsHovering] = useState(false);
  // Auto-cycle when not hovering
  useEffect(() => {
    if (isHovering) return;
    const timer = setInterval(() => {
      setActiveIndex(prev => (prev + 1) % steps.length);
    }, 3500);
    return () => clearInterval(timer);
  }, [isHovering]);
  return <section className="py-24 px-6 md:px-12 max-w-[1280px] mx-auto bg-bone" data-id="element-639">
      <div className="mb-16 flex flex-col md:flex-row md:items-end md:justify-between gap-6" data-id="element-640">
        <div data-id="element-641">
          <div className="text-xs font-semibold tracking-[0.2em] uppercase text-gold mb-4" data-id="element-642">
            Our Process
          </div>
          <h2 className="text-4xl md:text-5xl font-serif text-ink tracking-tight mb-4" data-id="element-643">
            How it works
          </h2>
          <p className="text-ink/60 max-w-md" data-id="element-644">
            A seamless, transparent journey to acquiring your dream property.
          </p>
        </div>

        {/* Progress indicators */}
        <div className="flex items-center gap-2" data-id="element-645">
          {steps.map((_, i) => <button key={i} onClick={() => setActiveIndex(i)} className="h-1 rounded-full overflow-hidden bg-ink/10 transition-all" style={{
          width: activeIndex === i ? '40px' : '20px'
        }} aria-label={`Go to step ${i + 1}`} data-id="element-646">
              {activeIndex === i && !isHovering && <motion.div key={`progress-${activeIndex}`} className="h-full bg-gold" initial={{
            width: '0%'
          }} animate={{
            width: '100%'
          }} transition={{
            duration: 3.5,
            ease: 'linear'
          }} data-id="element-647" />}
              {activeIndex === i && isHovering && <div className="h-full w-full bg-gold" data-id="element-648" />}
            </button>)}
        </div>
      </div>

      <div className="flex flex-col md:flex-row gap-4 h-auto md:h-[480px]" onMouseEnter={() => setIsHovering(true)} onMouseLeave={() => setIsHovering(false)} data-id="element-649">
        {steps.map((step, i) => {
        const isActive = activeIndex === i;
        return <motion.div key={i} layout onMouseEnter={() => setActiveIndex(i)} className={`relative rounded-2xl overflow-hidden cursor-pointer group ${isActive ? 'shadow-xl' : 'shadow-sm'}`} style={{
          flex: isActive ? 3 : 1
        }} transition={{
          duration: 0.6,
          ease: [0.16, 1, 0.3, 1]
        }} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-650">
              {/* Background Image */}
              <img src={step.image} alt={step.title} className="absolute inset-0 w-full h-full object-cover" data-id="element-651" />

              {/* Overlay */}
              <div className={`absolute inset-0 transition-colors duration-500 ${isActive ? 'bg-gradient-to-t from-ink via-ink/60 to-ink/30' : 'bg-ink/70'}`} data-id="element-652" />

              {/* Content */}
              <div className="relative h-full p-6 md:p-8 flex flex-col justify-between text-white" data-id="element-653">
                <div className="flex items-start justify-between" data-id="element-654">
                  <div className={`text-sm font-semibold tracking-widest transition-colors ${isActive ? 'text-gold' : 'text-white/60'}`} data-id="element-655">
                    STEP {step.num}
                  </div>
                  {isActive && <motion.div initial={{
                scale: 0,
                rotate: -45
              }} animate={{
                scale: 1,
                rotate: 0
              }} className="w-10 h-10 rounded-full bg-gold flex items-center justify-center" data-id="element-656">
                      <svg className="w-4 h-4 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" data-id="element-657">
                        <path d="M5 12h14M13 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" data-id="element-658" />
                      </svg>
                    </motion.div>}
                </div>

                <div data-id="element-659">
                  <h3 className={`font-serif mb-3 transition-all duration-500 ${isActive ? 'text-3xl md:text-4xl' : 'text-xl writing-vertical md:[writing-mode:vertical-rl] md:rotate-180'}`} data-id="element-660">
                    {step.title}
                  </h3>

                  <motion.div initial={false} animate={{
                opacity: isActive ? 1 : 0,
                height: isActive ? 'auto' : 0
              }} transition={{
                duration: 0.4
              }} className="overflow-hidden" data-id="element-661">
                    <p className="text-sm md:text-base leading-relaxed text-white/80 max-w-md" data-id="element-662">
                      {step.desc}
                    </p>
                  </motion.div>
                </div>
              </div>
            </motion.div>;
      })}
      </div>
    </section>;
}